import { useEffect, useState } from "react";
import Pago from "../page/Pagar";
import apiAntesala from "../../config/ConfigPublic";
import { useDispatch, useSelector } from "react-redux";
import { fetchMe, meState } from "../../web/models/users/Index";
import axios from "axios";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import restPublicApi from "../../helpers/RestPublicApi";
import Completado from "../page/Completado";
import RestPrivateAntesala from "../../helpers/RestPrivateApi";
import { profit } from "../utils/ValidarMembresia";
import apiPrivateAntesala from "../../config/ConfigPrivate";
import { format } from "date-fns";
import Alerts from "../../web/components/Alerts/Alerts";

const regex = /^[0-9/]*$/;

const PagoController = () => {
  const dispatch = useDispatch();
  const _me = useSelector(meState);
  const me = _me.me;
  const [visitante, setVisitante] = useState(null);
  const [required, setRequired] = useState({
    debito_credito: false,
    numero: false,
    titular: false,
    vencimiento: false,
    mes: false,
    año: false,
    codigo: false,
    tipo: false,
    focusCVV: false,
    email: false,
    telefono: false,
    dni: false,
    payment_method_id: false,
  });

  const [isChecked, setIsChecked] = useState(false)
  const [evento, setEvento] = useState(null);
  const [metodoPago, setMetodoPago] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reporte, setReporte] = useState(null);
  const [membresia, setMembresia] = useState(null);
  const [recaptcha, setRecaptcha] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState("");
  const [cupon, setCupon] = useState({
    data: null,
    msg: "",
  });
  const [apCupon, setApCupon] = useState(false);
  const [requestError, setRequestError] = useState({
    status: false,
    msg: "",
  });
  const [info, setInfo] = useState({
    debito: false,
    credito: false,
    dni: "",
    numero: "",
    titular: "",
    vencimiento: "",
    mes: "",
    año: "",
    codigo: "",
    tipo: null,
    focusCVV: false,
    email: "",
    telefono: "",
    payment_method_id: null,
  });

  const creditCard = [
    { id: 1, name: "Visa" },
    { id: 24, name: "Naranja" },
    { id: 104, name: "Mastercard" },
    { id: 111, name: "American Express" },
    { id: 111, name: "Cabal" },
  ];

  const debitCard = [
    { id: 31, name: "Visa" },
    { id: 105, name: "Mastercard" },
    { id: 106, name: "Maestro" },
    { id: 108, name: "Cabal" },
    { id: 114, name: "Visa Prepaga" },
    { id: 116, name: "MasterCard Prepaga" },
  ];

  const creditPaymentMethods = [
    { label: "Tarjeta Visa", value: 1 },
    { label: "Tarjeta Naranja", value: 24 },
    { label: "Tarjeta Cabal", value: 63 },
    { label: "Tarjeta American express", value: 111 },
    { label: "Tarjeta Mastercard", value: 104 },
    { label: "Tarjeta Nativa", value: 109 },
  ];
  const debitPaymentMethods = [
    { label: "Tarjeta Visa", value: 31 },
    { label: "Tarjeta Mastercard", value: 105 },
    { label: "Tarjeta Maestro", value: 106 },
    { label: "Tarjeta Cabal", value: 108 },
    { label: "Tarjeta Visa Prepaga", value: 114 },
    { label: "Tarjeta MasterCard Prepaga", value: 116 },
  ];

  const resetCheckout = () => {
    setIsChecked(false);
    setRecaptcha(null);
    setLoading(false);
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "tipo":
        {
          setRequestError({ status: false, msg: "" });
          setRequired({ ...required, debito_credito: false });
          if (e.target.value == "debito") {
            setInfo({ ...info, debito: true, credito: false });
          }

          if (e.target.value == "credito") {
            setInfo({ ...info, debito: false, credito: true });
          }
        }
        break;
      case "mes":
        {
          setRequired({ ...required, mes: false });
          setInfo({
            ...info,
            mes: e.target.value,
            vencimiento: e.target.value.padStart(2, '0') + "/" + info.año,
          });
        }
        break;
      case "año":
        {
          setRequired({ ...required, año: false });
          setInfo({
            ...info,
            año: e.target.value,
            vencimiento: info.mes.padStart(2, '0') + "/" + e.target.value,
          });
        }
        break;
      case "dni":
      case "email":
      case "telefono":
      case "titular":
      case "payment_method_id":
      case "codigo":
        {
          setRequestError({ status: false, msg: "" });
          setRequired({ ...required, [e.target.name]: false });
          setInfo({
            ...info,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "numero":
        {
          if (isNaN(e.target.value)) {
            return null;
          }

          setRequestError({ status: false, msg: "" });
          setRequired({ ...required, numero: false });

          let tipo = null;
          if (e.target.value[0] == "4") {
            tipo = "visa";
          }

          if (
            ["51", "52", "53", "54", "55"].includes(
              e.target.value[0] + e.target.value[0]
            )
          ) {
            tipo = "mastercard";
          }

          if (
            ["50", "56", "69"].includes(e.target.value[0] + e.target.value[1])
          ) {
            tipo = "maestro";
          }

          if (["34", "37"].includes(e.target.value[0] + e.target.value[1])) {
            tipo = "amex";
          }

          setInfo({
            ...info,
            [e.target.name]: e.target.value.replace(
              new RegExp(" ".replace(/\./g, "\\."), "gi"),
              ""
            ),
            tipo: tipo,
          });
        }
        break;
      case "cupon":
        {
          console.log(evento.evento)
          let cuponEvento = evento.evento.cupones.filter(
            (c) => c.nombre.toUpperCase() == e.target.value.toUpperCase()
          );

          if (cuponEvento.length > 0) {
            cuponEvento = cuponEvento[0];

            if (
              cuponEvento.fechas_funciones.filter(
                (f) => f.fechas[0] == evento.select.fecha
              ).length == 0
            ) {
              return setCupon({
                ...cupon,
                data: null,
                msg: "El cupon no esta habilitado para esta fecha de función",
              });
            }

            let params = {
              codigo: cuponEvento.codigo,
            };
            const response = await apiPrivateAntesala("/cupones/validar", {
              params,
            });


            if (!response.data.data) {
              return setCupon({
                ...cupon,
                data: null,
                msg: `El cupón ha superado el límite establecido.`,
              });
            }

            setCupon({
              ...cupon,
              data: cuponEvento,
              msg: `Cupon habilitado ${cuponEvento.descuento}% Descuento`,
            });
          }
        }
        break;
      default:
        break;
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "quitar-membresia":
        {
          setMembresia(null);
        }
        break;
      case "abonar-con-membresia":
        {
          setMembresia(value);
        }
        break;
      case "pagar_mercado_pago":
        {
          let _required = required;
          let error = false;

          // Validar solo campos personales para Mercado Pago
          if (!info.titular || String(info.titular).trim() === "") {
            _required.titular = true;
            error = true;
          } else {
            _required.titular = false;
          }

          if (!info.email || String(info.email).trim() === "") {
            _required.email = true;
            error = true;
          } else {
            _required.email = false;
          }

          if (!info.telefono || String(info.telefono).trim() === "") {
            _required.telefono = true;
            error = true;
          } else {
            _required.telefono = false;
          }

          setRequired({ ..._required });
          if (error) {
            return null;
          }


          const formdata = new FormData();
          formdata.append("nombre", info.titular);
          formdata.append("email", info.email);
          formdata.append("telefono", info.telefono);
          formdata.append("id_evento", evento.evento.id);
          formdata.append("fecha", evento.select.fecha);
          formdata.append("hora", evento.select.hora);
          formdata.append("action", "button_press");

          const entradas = profit({ evento, membresia, cupon });
          entradas.evento.entradas.map((entrada, index) => {
            if (entrada.quantity > 0) {
              formdata.append("entradas[" + index + "][id]", entrada.id);
              formdata.append("entradas[" + index + "][quantity]", entrada.quantity);

              if (entrada.membresia) {
                formdata.append("entradas[" + index + "][membresia]", entrada.membresia);
              }
            }
          });

          if (cupon.data) {
            formdata.append("cupon", cupon.data.codigo);
          }

          const result = await RestPrivateAntesala({
            url: "/checkout/payment-mercadopago",
            formData: formdata,
            setLoading: setLoading,
            method: "POST",
          });

          console.log(result)

          if (result.status == 200 || result.status == 201) {
            if (result.data.data.sandbox_init_point) {
              window.location.href = result.data.data.sandbox_init_point;
            }
          } else {
            resetCheckout();
            setRequestError({
              ...requestError,
              status: true,
              msg: result.data?.msg || "Ocurrió un error al procesar el pago con Mercado Pago",
            });
            return Alerts({
              msg: "Alert",
              title: "Ocurrió un error al procesar el pago con Mercado Pago",
              code: "200",
              type: "error",
            });
          }
        }
        break;
      case "pagar":
        {
          let _required = required;
          let error = false;

          /**Permitir validacion */
          if (profit({ evento, membresia, cupon }).info.total > 0) {
            Object.keys(required).map((key) => {
              if (
                key !== "debito" &&
                key !== "credito" &&
                key !== "payment_method_id" &&
                key !== "vencimiento" &&
                String(info[key]).trim() == ""
              ) {
                _required[key] = true;
                error = true;
              } else {
                if (
                  key !== "debito" &&
                  key !== "credito" &&
                  key !== "payment_method_id" &&
                  key !== "vencimiento"
                ) {
                  _required[key] = false;
                }
              }
            });

            if (!info["credito"] && !info["debito"]) {
              _required["debito_credito"] = true;
              error = true;
            } else {
              _required["debito_credito"] = false;
            }

            if (!info["payment_method_id"]) {
              _required["payment_method_id"] = true;
              error = true;
            } else {
              _required["payment_method_id"] = false;
            }

            setRequired({ ..._required });
            if (error) {
              if (!info["payment_method_id"]) {
                setRequestError({
                  status: true,
                  msg: "Por favor selecciona un método de pago válido antes de continuar."
                });
              }
              return null;
            }
          } else {
            Object.keys(required).map((key) => {
              if (
                (key == "titular" && String(info[key]).trim() == "") ||
                (key == "email" && String(info[key]).trim() == "") ||
                (key == "telefono" && String(info[key]).trim() == "")
              ) {
                _required[key] = true;
                error = true;
              }
            });

            setRequired({ ..._required });
            if (error) {
              return null;
            }

            if (!recaptcha) {
              setRecaptchaError("Acepte terminos y condiciones antes de avanzar");
              return;
            }

            const formdata = new FormData();
            formdata.append("nombre", info.titular);
            formdata.append("email", info.email);
            formdata.append("telefono", info.telefono);
            //formdata.append("bin", response.data.bin);
            //formdata.append("payment_method", payment_method_id);
            formdata.append("id_evento", evento.evento.id);
            formdata.append("fecha", evento.select.fecha);
            formdata.append("hora", evento.select.hora);
            formdata.append("grecaptcha", recaptcha);
            formdata.append("action", 'button_press');

            let cantidadValidateMembership = 0;
            let totalValidateMembership = 0;

            const entradas = profit({ evento, membresia, cupon });
            entradas.evento.entradas.map((entrada, index) => {
              if (entrada.quantity ?? null & entrada.membresia ?? null) {
                formdata.append("entradas[" + index + "][id]", entrada.id);
                formdata.append(
                  "entradas[" + index + "][quantity]",
                  entrada.quantity
                );
              }

              if (entrada.membresia) {
                formdata.append("entradas[" + index + "][id]", entrada.id);
                formdata.append(
                  "entradas[" + index + "][quantity]",
                  entrada.quantity
                );
                formdata.append(
                  "entradas[" + index + "][membresia]",
                  entrada.membresia
                );

                cantidadValidateMembership = entrada.quantity + cantidadValidateMembership;
                totalValidateMembership = totalValidateMembership + entrada.pricexquantity + entrada.serv;
              }
            });

            if (membresia) {
              formdata.append("membresia", membresia.code);

              const formValidate = new FormData();
              formValidate.append('membresia', membresia.code);
              formValidate.append('cantidad', cantidadValidateMembership);
              formValidate.append('total', totalValidateMembership);

              const isMembership = await RestPrivateAntesala({
                url: "/memberships/validate",
                formData: formValidate,
                setLoading: () => { },
                method: "POST",
              });

              if (isMembership.status !== 200) {
                resetCheckout()
                return setRequestError({
                  ...requestError,
                  status: true,
                  msg: "Membresia invalida. no hay mas cupos validos.",
                });
              }
            }

            if (cupon.data) {
              formdata.append("cupon", cupon.data.codigo);
            }

            const result = await RestPrivateAntesala({
              url: "/checkout/payment",
              formData: formdata,
              setLoading: setLoading,
              method: "POST",
            });

            if (result.status == 200) {
              return setReporte({
                reporte: result.data.data,
              });
            } else {
              resetCheckout()
              setRequestError({
                ...requestError,
                status: true,
                msg: "Ocurrio un error con su membresia",
              });
              return Alerts({
                msg: "Alert",
                title: "Ocurrio un error con su membresia",
                code: "200",
                type: "error",
              });
            }
          }

          if (!recaptcha) {
            setRecaptchaError("Acepte terminos y condiciones antes de avanzar");
            return;
          }

          function convertirAnoCorto(anio) {
            anio = anio.toString();
            if (anio.length === 4) {
              return anio.slice(2);
            }
            return anio;
          }

          let formToken = {
            card_number: info.numero,
            card_expiration_month: info.mes,
            card_expiration_year: info.año,
            security_code: info.codigo,
            card_holder_name: info.titular,
            card_holder_identification: {
              type: "dni",
              number: info.dni,
            },
            fraud_detection: {
              device_unique_identifier: visitante,
            },
            ip_address: "192.168.100.1",
          };

          if (info.credito) {
            formToken = {
              ...formToken,
              card_holder_birthday: format(new Date(), "ddMMyyyy").toString(),
              card_holder_door_number: parseInt(info.codigo),
            };
          }

          const key = process.env.REACT_APP_PUBLIC_KEY_PRODUCTION;
          const url = process.env.REACT_APP_URL_PRODUCTION;

          //const key = process.env.REACT_APP_PUBLIC_KEY_LOCAL;
          //const url = process.env.REACT_APP_URL_LOCAL;

          const response = await axios({
            method: "post",
            url: url,
            headers: {
              apikey: key,
            },
            data: formToken,
          });

          if (response.status == 201) {
            const token = response.data.id;
            let payment_method_id = null;

            if (info.credito) {
              payment_method_id = parseInt(info.payment_method_id);
            }

            if (info.debito) {
              payment_method_id = parseInt(info.payment_method_id);
            }

            const formdata = new FormData();
            formdata.append("nombre", info.titular);
            formdata.append("email", info.email);
            formdata.append("telefono", info.telefono);
            formdata.append("bin", response.data.bin);
            formdata.append("payment_method", payment_method_id);
            formdata.append("id_evento", evento.evento.id);
            formdata.append("fecha", evento.select.fecha);
            formdata.append("hora", evento.select.hora);
            formdata.append("grecaptcha", recaptcha);
            formdata.append("action", 'button_press');

            if (cupon.data) {
              formdata.append("cupon", cupon.data.codigo);
            }

            const entradas = profit({ evento, membresia, cupon });
            entradas.evento.entradas.map((entrada, index) => {
              if (entrada.quantity ?? null & entrada.membresia ?? null) {
                formdata.append("entradas[" + index + "][id]", entrada.id);
                formdata.append(
                  "entradas[" + index + "][quantity]",
                  entrada.quantity
                );
              }

              if (entrada.membresia) {
                formdata.append("entradas[" + index + "][id]", entrada.id);
                formdata.append(
                  "entradas[" + index + "][quantity]",
                  entrada.quantity
                );
                formdata.append(
                  "entradas[" + index + "][membresia]",
                  entrada.membresia
                );
              }
            });

            formdata.append("token", token);
            if (membresia) {
              formdata.append("membresia", membresia.code);
            }

            if (cupon.data) {
              formdata.append("cupon", cupon.data.codigo);
            }

            const result = await RestPrivateAntesala({
              url: "/checkout/payment",
              formData: formdata,
              setLoading: setLoading,
              method: "POST",
            });

            if (result.status == 200 || result.status == 201) {

              /**generar evento meta pixel*/
              if (window.fbq) {
                try {
                  const metaData = profit({ evento, membresia, cupon });
                  const contents = metaData.evento?.entradas
                    .filter((entrada) => entrada && entrada.id && entrada.quantity > 0)
                    .map((entrada) => {
                      const precio = parseFloat(entrada?.pricexquantity) / entrada.quantity;
                      const precioCompleto = Number(precio) + (Number(precio) / 100 * metaData.evento?.comisiones.tasa)
                      return {
                        id: entrada.id.toString(),
                        quantity: entrada.quantity,
                        item_price: Number(precioCompleto.toFixed(2))
                      }
                    });

                  const eventId = `purchase_${Date.now()}_${evento.evento.id}`;
                  window.fbq('track', 'Purchase', {
                    value: Number(metaData.info.total.toFixed(2)),
                    currency: 'ARS',
                    num_items: contents.reduce((acc, item) => acc + item.quantity, 0),
                    contents,
                    content_ids: contents.map(x => x.id),
                    content_type: 'product',
                    eventID: eventId
                  });
                } catch (error) {
                }
              }

              setTimeout(() => {
                window.location.href = `/completado/${evento.evento.id}`;
              }, 500);
            } else {
              resetCheckout();
              if (typeof result.data.msg == 'String') {
                setRequestError({
                  ...requestError,
                  status: true,
                  msg: result.data.msg,
                });
              } else {
                setRequestError({
                  ...requestError,
                  status: true,
                  msg: 'Ocurrio un error con su tarjeta. por favor comuniquese con soporte para obtener información detallada',
                });
              }
              return Alerts({
                msg: "Alert",
                title: "Ocurrio un error en la transaccion esperada",
                code: "200",
                type: "error",
              });
            }
          } else {
            resetCheckout();
            setRequestError({
              ...requestError,
              status: true,
              msg: "Ocurrio un error con los datos de su tarjeta",
            });
            return Alerts({
              msg: "Alert",
              title: response.data?.msg,
              code: "200",
              type: "error",
            });
          }
        }
        break;
      default:
        break;
    }
  };

  const fetch = async (setData, params, url) => {
    const response = await apiAntesala.get(url, { params });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!evento) {
      let local = localStorage.getItem("entradas");
      if (local) {
        local = JSON.parse(local);
        setEvento(local);
      }
    }
  }, []);

  useEffect(() => {
    if (!metodoPago) {
      fetch(setMetodoPago, {}, "/checkout/metodo-pago");
    }
  }, []);

  useEffect(() => {
    const fetchFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setVisitante(result.visitorId);
    };

    fetchFingerprint();
  }, []);

  useEffect(() => {
    if (!me) {
      let params = {
        url: "/auth/me",
      };
      dispatch(fetchMe(params));
    }
  }, []);

  useEffect(() => {
    if (me) {
      setInfo({
        debito: false,
        credito: false,
        dni: "",
        numero: "",
        titular: `${me?.nombre} ${me?.apellido}`,
        vencimiento: "",
        mes: "",
        año: "",
        codigo: "",
        tipo: null,
        focusCVV: false,
        email: me?.email,
        telefono: me?.telefono,
      });
    }
  }, [me]);

  if (!evento) {
    return "";
  }

  if (reporte) {
    return <Completado reporte={reporte} me={me} />;
  }


  return (
    <Pago
      info={info}
      evento={profit({ evento, membresia, cupon })}
      setInfo={setInfo}
      onChange={onChange}
      onClick={onClick}
      required={required}
      loading={loading}
      me={me}
      membresia={membresia}
      cupon={cupon}
      apCupon={apCupon}
      setApCupon={setApCupon}
      creditPaymentMethods={creditPaymentMethods}
      debitPaymentMethods={debitPaymentMethods}
      creditCard={creditCard}
      debitCard={debitCard}
      setRecaptcha={(value) => {
        setRecaptcha(value);
        if (value) {
          setRecaptchaError("");
        }
      }}
      recaptchaError={recaptchaError}
      requestError={requestError}
      isChecked={isChecked}
      setIsChecked={setIsChecked}
    />
  );
};

export default PagoController;
